import { EU_SUBMITION_BUTTON } from './types';
import { callAPI } from 'Action';
import { appConstantUrl } from 'appConstant';

export const getEudrSubmissionResult = (value: any) => async (dispatch) => {
  let url = appConstantUrl.euSubmitUrl;
  let reqObj = value;

  const options = {
    url,
    method: 'POST',
    actionType: EU_SUBMITION_BUTTON,
    dispatch,
    reqObj,
  };
  let data = await callAPI(options);
  if (data) {
    dispatch({
      type: EU_SUBMITION_BUTTON,
      payload: data,
    });
  }
  return data;
};
